import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { UnavailableSlotsForm } from "@/components/schedule/form/unavailable-slots-form";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { formatWithZonedDate, getCurrentDate } from "@/lib/helpers/date";

import type { JSX } from "react";

const unavailableSlotSchema = z.object({
  date: z
    .string()
    .optional()
    .refine((value) => !value || /^\d{4}-\d{2}-\d{2}$/.test(value))
    .catch(formatWithZonedDate(getCurrentDate())),
  locationId: z.number().optional(),
  start: z.string().optional(),
  end: z.string().optional(),
});

const UnavailableSlotsPageQuery = graphql(`
  query UnavailableSlotsPageQuery($dataInicio: date!) {
    usuariosAgendas(
      where: {
        ativo: { _eq: true }
        tbUsuariosAgendasCompromissos: { ativo: { _eq: true } }
        _or: [{ dataFim: { _gte: $dataInicio } }, { dataFim: { _is_null: true } }]
      }
    ) {
      ...UnavailableSlotFormFragment
    }
  }
`);

const UnavailableSlotsCreate = (): JSX.Element => {
  const queryResult = useGraphQL(UnavailableSlotsPageQuery, {
    dataInicio: formatWithZonedDate(new Date(), "yyyy-MM-dd"),
  });

  const { data: queryData } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderTitle title="Fechar agenda" align="center" />
        <HeaderButton icon={Left} align="start" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {queryData ? (
            <UnavailableSlotsForm queryData={queryData.usuariosAgendas} />
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/calendar/unavailable-slots/create")({
  component: UnavailableSlotsCreate,
  validateSearch: (search) => unavailableSlotSchema.parse(search),
});
